import { MasterDataService, ConfigService } from '@nextgen-web-framework/core';
import { type CartConfig } from '@com.amway.commerce/cart-cartconfig-v1-prod/Schema';
import { AccountType } from '../services/models/AccountType';
import { OrderType } from '../services';

export const getCountrySpecificMasterConfig = () => {
  const masterData = MasterDataService.getMasterData<CartConfig>('CartConfig') as CartConfig[];
  const currentLocale = ConfigService.getConfigs().NEXT_PUBLIC_COUNTRY as string;
  return masterData?.find((data: CartConfig) => data?.pk?.toLowerCase() === currentLocale?.toLowerCase());
};

export const getGroupCartConfig = () => getCountrySpecificMasterConfig()?.isGroupCart;

export const getListCountConfig = () => getCountrySpecificMasterConfig()?.listCount;

export const getdefaultRegistrtaionConfig = () => getCountrySpecificMasterConfig()?.enableDefaultRegistration;

export const getshowPromoUnavailablePopupConfig = () =>
  getCountrySpecificMasterConfig()?.showPromotionUnavailablePopup ?? true;

export const getOrderTypeConfig = () => getCountrySpecificMasterConfig()?.orderType as OrderType;

export const getEKitTermsAndConditionsConfig = () => {
  const accountDetails = getCountrySpecificMasterConfig()?.accountProcess as {
    showEkitTermsCondition: boolean;
  };
  return accountDetails?.showEkitTermsCondition;
};

export const getInstallmentConfig = () => {
  const installmentDetails = getCountrySpecificMasterConfig()?.paymentDetails as {
    paymentPlanId: string;
    paymentPlanTitle: string;
    paymentMethod: string;
  };
  return {
    installmentPlanIdFromConfig: installmentDetails?.paymentPlanId,
    installmentPlanTitleFromConfig: installmentDetails?.paymentPlanTitle,
    installmentPaymentMethod: installmentDetails?.paymentMethod,
  };
};

export const getMarketOrderType = () => {
  const envConfigGCO = getCountrySpecificMasterConfig()?.enableGroupCart as {
    default: boolean;
    [k: string]: boolean;
  };
  const env = ConfigService.getConfigs().NEXT_SSR_BASE_PATH as string;
  return {
    isGCOEnabledForMarket: envConfigGCO?.[env] ?? envConfigGCO?.default,
    isProxyOrderEnabledForMarket: getCountrySpecificMasterConfig()?.isProxyOrderEnabled as boolean,
  };
};

export const getProductCode = (userAccounttype: string) => {
  let userType: 'abo' | 'member' = 'member';

  if (userAccounttype === AccountType.BusinessOwner) {
    userType = 'abo';
  }

  const accountDetails = getCountrySpecificMasterConfig()?.accountProcess as {
    registration: {
      abo: {
        fee: string;
      };
      member: {
        fee: string;
      };
    };
  };

  return {
    productCode: accountDetails?.registration[userType]?.fee,
  };
};

export const getpkitAndeKitProductId = () => {
  const userType = 'abo';
  type RegistrationKeys = 'eKit' | 'pKit';
  const accountDetails = getCountrySpecificMasterConfig()?.accountProcess as {
    registration: {
      abo: {
        eKit: string;
        pKit: string;
        fee: string;
        default: RegistrationKeys;
      };
    };
  };
  const defaultKit: RegistrationKeys = accountDetails?.registration[userType].default;

  return {
    pkitProductId: accountDetails?.registration[userType].pKit,
    ekitProductId: accountDetails?.registration[userType].eKit,
    defaultKitId: accountDetails?.registration[userType][defaultKit],
  };
};

export const getGuestCheckoutConfig = () => {
  const env = ConfigService.getConfigs().NEXT_SSR_BASE_PATH as string;
  const checkoutConfigGCO = getCountrySpecificMasterConfig()?.isGuestCheckout as {
    default: boolean;
    [k: string]: boolean;
  };

  return checkoutConfigGCO?.[env] ?? checkoutConfigGCO?.default;
};

export const getCreateAccountConfig = () => {
  const env = ConfigService.getConfigs().NEXT_SSR_BASE_PATH as string;
  const createAccountConfig = getCountrySpecificMasterConfig()?.isCreateAccountEnabled as {
    default: boolean;
    [k: string]: boolean;
  };

  return createAccountConfig?.[env] ?? createAccountConfig?.default;
};

export const getMaxProductQty = () => Number(getCountrySpecificMasterConfig()?.maxProductQty);

export const getAwardLevelConfig = () => MasterDataService.getMasterData('AwardConfig') as unknown[];
export const switchCartNewStrategy = () => !!getCountrySpecificMasterConfig()?.switchOrderTypeSubCartDeletion;
export const hidePromoUnavailablePopup = () => !!getCountrySpecificMasterConfig()?.hidePromoUnavailablePopup;
export const showEditLabel = () => !!getCountrySpecificMasterConfig()?.showEditLabel;
export const showRecommendedProducts = () => !!getCountrySpecificMasterConfig()?.showRecommendedProducts;
export const hideBV = () => !!getCountrySpecificMasterConfig()?.hideBV;
export const hidePromotionBanner = () => !!getCountrySpecificMasterConfig()?.hidePromotionBanner;

export { type CartConfig };
